import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { ITurnoDTO, ITurnoEdit } from "../../../../../Interfaces/auxiliar/ITurno";
import { PanelHeader } from "../../../../../components/Panel/PanelHeader";
import { Panel, TextField } from "@fluentui/react";
import { usePanelEditar } from "./usePanelEditar";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { MessageBarResponse } from "../../../../../components/MessageBarResponse/MessageBarResponse";
import { ProgressBarLoading } from "../../../../../components/ProgressBarLoading/ProgressBarLoading";
import { PanelHeaderBasic } from "../../../../../components/Panel/PanrlHeaderBasic";


export interface IPanelTurnoEduitar extends IOpenPanel{
    item: ITurnoEdit
}


export const PanelTurnoEditar=(props:IPanelTurnoEduitar)=>{
    const {request,setRequest,putEditarTurno,loading,disableForm,reset,mensaje,status} = usePanelEditar(props)
    const onRenderHeader = useCallback(
        () => (
          <PanelHeaderBasic
          subTextHeader=""
          textHeader="Editar Turno"
        />
        ),
        []
      );
     
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto="Editar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={putEditarTurno}
              onDismiss={reset}
            />
          </>
        ),
        [request]
      );
    return (
        <Panel 
        isOpen={props.isOpen}
        onDismiss={reset}
        isFooterAtBottom
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        >
        <div hidden={mensaje == ""}>
        <MessageBarResponse
          objetoResponse={{ codigo: status, mensaje: mensaje }}
          close={true}
        />
      </div>
       <div hidden={!loading}>
        <ProgressBarLoading></ProgressBarLoading>
       </div>
      <div hidden={loading}>
      {!mensaje && (
        <>
      <TextField 
         type="text"
         label="Nombre de Turno"
         placeholder="Ingrese Nombre"
         autoComplete="off"
         value={request.nombre}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombre:newValue})}
         }}
         />
         <TextField 
         type="text"
         label="Codigo de Turno"
         placeholder="Ingrese Codigo"
         autoComplete="off"
         value={request.codigo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,codigo:newValue})}
         }}
         />
         <TextField 
         type="time"
         label="Hora Inicio"
         placeholder="Ingrese Hora Inicio"
         autoComplete="off"
         value={request.horaInicio}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,horaInicio:newValue})}
         }}
         />
         <TextField 
         type="time"
         label="Hora Fin"
         placeholder="Ingrese Hora Fin"
         autoComplete="off"
         value={request.horaFin}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,horaFin:newValue})}
         }}
         />
         </>)}

      </div>

        </Panel>
    )

}